// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import InternalControlGroup from './internal';
export default function ControlGroup({ direction = 'auto', ...props }) {
    const baseComponentProps = useBaseComponent('ControlGroup', {
        props: { direction },
        metadata: {
            hasInlineLabel: Boolean(props.inlineLabelText),
            hasActionButton: Boolean(props.actionButton),
        },
    });
    return React.createElement(InternalControlGroup, { direction: direction, ...props, ...baseComponentProps });
}
applyDisplayName(ControlGroup, 'ControlGroup');
//# sourceMappingURL=index.js.map